import styled from 'styled-components';

import { SafeMotionDiv } from '../../animation/SafeMotionDiv';

interface $ContentProps {
  $height: number;
}

const $Content = styled(SafeMotionDiv)<$ContentProps>`
  position: relative;
`;

export default $Content;
